// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.y1rX4QVq_1 {
  width: 369px;
  padding: 4px;
  box-shadow: 0 0 2px 2px rgba(0, 0, 0, 0.06);
  float: left;
  background: #fff;
}
.y1rX4QVq_1 h4 {
  line-height: 3em;
}
.y1rX4QVq_1 .obeG_q15nE {
  float: left;
  width: 100%;
}
.y1rX4QVq_1 .iubygwU9XV {
  height: 40px;
  width: 60px;
  float: left;
  display: inline-block;
  min-height: 0;
  border-radius: 0;
  margin-bottom: 0;
  position: relative;
}
.y1rX4QVq_1 .iubygwU9XV:hover {
  cursor: pointer;
}
.y1rX4QVq_1 .iubygwU9XV:hover:after {
  position: absolute;
  content: "";
  z-index: 10;
  height: 40px;
  width: 60px;
  top: 0;
  left: 0;
  background: rgba(255, 255, 255, 0.3);
}
.Vc2aA3gD4r .NBe34EQUb8:focus {
  outline: none;
}
.Vc2aA3gD4r .NBe34EQUb8.epgX1DOQO1.Cka_qhwnhm {
  background: #375A88;
}
.Vc2aA3gD4r .NBe34EQUb8.epgX1DOQO1.Cka_qhwnhm span {
  color: #fff;
}
.Vc2aA3gD4r .Cka_qhwnhm {
  background: #F5F4F9;
  border: 1px solid rgba(0, 0, 0, 0.06);
  color: rgba(0, 0, 0, 0.2);
}
.Vc2aA3gD4r .Cka_qhwnhm:hover {
  background: #4F5157;
  color: #fff;
  border: 1px solid rgba(0, 0, 0, 0.06);
}
.Vc2aA3gD4r input {
  height: 38px;
  min-width: 220px;
}
.iubygwU9XV.N4f6D_73vM {
  background: #410102;
}
.iubygwU9XV.L6AVIf556c {
  background: #911318;
}
.iubygwU9XV.avgOO6X9Pz {
  background: #D8293B;
}
.iubygwU9XV.pExkGp42JE {
  background: #F2373C;
}
.iubygwU9XV.qn0g6NfRKp {
  background: #FC4448;
}
.iubygwU9XV.MTiTuotXY8 {
  background: #ED535E;
}
.iubygwU9XV.tnQKhvTxj3 {
  background: #E34926;
}
.iubygwU9XV.qlQBRTKRT2 {
  background: #FC562B;
}
.iubygwU9XV.JcELR7BxSg {
  background: #FC6722;
}
.iubygwU9XV.lRXXS5X7fN {
  background: #FD7F24;
}
.iubygwU9XV.RG_qBLIsKl {
  background: #FD8D26;
}
.iubygwU9XV.CKrqKlaUAq {
  background: #EC9C3E;
}
.iubygwU9XV.tGjUoaARpY {
  background: #0e673a;
}
.iubygwU9XV.e_W0tNYNw1 {
  background: #208740;
}
.iubygwU9XV.ZoyX9xfqT8 {
  background: #239718;
}
.iubygwU9XV.OvhkVFcgJv {
  background: #55A84D;
}
.iubygwU9XV.wc2at_vASK {
  background: #4BBE5A;
}
.iubygwU9XV.aFP0XFSukZ {
  background: #0CCA6A;
}
.iubygwU9XV.kTULXPfKVp {
  background: #0A3C64;
}
.iubygwU9XV.ELBsw9Ct6D {
  background: #0d487a;
}
.iubygwU9XV.Bl8pp0ubDh {
  background: #10538d;
}
.iubygwU9XV.BRZBdVMQNk {
  background: #115A99;
}
.iubygwU9XV.S2NnYtDnYG {
  background: #3387E2;
}
.iubygwU9XV.TTJNhy0xjN {
  background: #1BA9CF;
}
.iubygwU9XV.HR0cWlV0S9 {
  background: #d27c02;
}
.iubygwU9XV.wWp63iVORv {
  background: #fb9402;
}
.iubygwU9XV.kkZ0kt7UUF {
  background: #FD9B30;
}
.iubygwU9XV.HJQp43NO8X {
  background: #FDBE2D;
}
.iubygwU9XV.hNKOJBTicn {
  background: #FED831;
}
.iubygwU9XV.C_e67KNyt7 {
  background: #FFFD38;
}
.iubygwU9XV.meT418sFNa {
  background: #2D215C;
}
.iubygwU9XV.Mp7HWaE5UK {
  background: #483C83;
}
.iubygwU9XV.FwNo4ADtBj {
  background: #58518d;
}
.iubygwU9XV.bKOE8PGdCM {
  background: #7068A9;
}
.iubygwU9XV.iD2f5y_ZhX {
  background: #7f78b2;
}
.iubygwU9XV.AouyJPQADd {
  background: #8f88bc;
}
.iubygwU9XV.l4KMbECR7F {
  background: #000;
}
.iubygwU9XV.FjlugI7yTW {
  background: #282626;
}
.iubygwU9XV.XIGwTjPWdO {
  background: #242222;
}
.iubygwU9XV.hPgjmKNgFP {
  background: #353838;
}
.iubygwU9XV.kTFEczd9J_ {
  background: #666;
}
.iubygwU9XV.eUuady9LwQ {
  background: #999;
}
.sGR89rurjG {
  background: none;
  margin-top: 120px;
  position: relative;
  margin-left: 10px;
}
.sGR89rurjG .af_tyDscED {
  display: none;
}
.pr_0pVY6tK {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  min-width: 720px;
  font-size: 11px;
  align-items: unset;
  margin: 40px;
}
.pr_0pVY6tK .ni5KxILZnL {
  position: relative;
  margin-top: 8px;
  margin-bottom: 16px;
}
.pr_0pVY6tK .ni5KxILZnL .jINu3fzujX {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 12px;
}
.pr_0pVY6tK .ni5KxILZnL .jINu3fzujX .rEsIQtgViw {
  width: 100%;
}
.pr_0pVY6tK .ni5KxILZnL .jINu3fzujX .rEsIQtgViw .C420CfwjvK {
  background-color: #F4F6F8;
}
.pr_0pVY6tK .ni5KxILZnL .jINu3fzujX .rEsIQtgViw .BL9KcklRC5 {
  font-size: 14px !important;
  height: 44px;
}
.pr_0pVY6tK .ni5KxILZnL .jINu3fzujX .rEsIQtgViw .HXgNQ72ueQ {
  border-color: #EA3344;
  color: #EA3344;
}
.pr_0pVY6tK .ni5KxILZnL .jINu3fzujX .rEsIQtgViw .BL9KcklRC5::placeholder {
  font-size: 14px;
  padding-left: 12px;
  font-style: normal;
}
.pr_0pVY6tK .ni5KxILZnL .jINu3fzujX .cXrRBMIPQb {
  margin-left: 24px;
  cursor: pointer;
  font-size: 16px;
  font-weight: 700;
}
.pr_0pVY6tK .ni5KxILZnL .jINu3fzujX .MLWLoRzsq7 {
  display: none;
}
.pr_0pVY6tK .ni5KxILZnL .jINu3fzujX:first-child {
  margin-top: 0;
}
.pr_0pVY6tK .ni5KxILZnL .IVyPx8GsGT {
  position: absolute;
  right: 0;
  color: #EA3344;
  font-size: 14px;
  margin-top: 4px;
}
.pr_0pVY6tK .tvaI80UHKc {
  font-weight: bold;
  text-transform: uppercase;
}
.pr_0pVY6tK .tL_rN3xII_ {
  display: flex;
  justify-content: center;
  align-items: center;
  justify-content: flex-start;
}
.pr_0pVY6tK .tL_rN3xII_ .O8_pXzvisb .SWEQoXRoLU input {
  text-align: center;
  border-radius: 3px;
}
.pr_0pVY6tK .tL_rN3xII_ .O8_pXzvisb .SWEQoXRoLU input:checked {
  background-color: #00739a;
}
.pr_0pVY6tK .tL_rN3xII_ .O8_pXzvisb .SWEQoXRoLU::before {
  font-size: 10px;
  vertical-align: middle;
}
.pr_0pVY6tK .tL_rN3xII_ .GgiACtnuWl,
.pr_0pVY6tK .tL_rN3xII_ .u73Eg3J835 {
  font-size: 10px !important;
  font-weight: bold;
}
.pr_0pVY6tK .tL_rN3xII_ .hqGKF8zbzt {
  cursor: pointer;
  text-align: center;
  border-bottom: 1px solid #707070;
}
.pr_0pVY6tK .tL_rN3xII_ .hqGKF8zbzt .GpNJM0Rz0j {
  margin-left: 10px;
}
.pr_0pVY6tK .tL_rN3xII_ .Ni_kJsGDen {
  display: flex;
}
.pr_0pVY6tK .tL_rN3xII_ .ziy4PS9FCb {
  margin: 0 8px;
}
.pr_0pVY6tK .tL_rN3xII_ .ziy4PS9FCb input {
  text-align: center;
  border-radius: 100%;
  background-image: none;
  background: #AAB7C4;
}
.pr_0pVY6tK .tL_rN3xII_ .ziy4PS9FCb input:checked {
  background-color: #00739a;
  background-image: none;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"color-picker": `y1rX4QVq_1`,
	"color-row": `obeG_q15nE`,
	"color-tile": `iubygwU9XV`,
	"picker-component": `Vc2aA3gD4r`,
	"picker-element": `NBe34EQUb8`,
	"active": `epgX1DOQO1`,
	"btn": `Cka_qhwnhm`,
	"red-1": `N4f6D_73vM`,
	"red-2": `L6AVIf556c`,
	"red-3": `avgOO6X9Pz`,
	"red-4": `pExkGp42JE`,
	"red-5": `qn0g6NfRKp`,
	"red-6": `MTiTuotXY8`,
	"orange-1": `tnQKhvTxj3`,
	"orange-2": `qlQBRTKRT2`,
	"orange-3": `JcELR7BxSg`,
	"orange-4": `lRXXS5X7fN`,
	"orange-5": `RG_qBLIsKl`,
	"orange-6": `CKrqKlaUAq`,
	"green-1": `tGjUoaARpY`,
	"green-2": `e_W0tNYNw1`,
	"green-3": `ZoyX9xfqT8`,
	"green-4": `OvhkVFcgJv`,
	"green-5": `wc2at_vASK`,
	"green-6": `aFP0XFSukZ`,
	"blue-1": `kTULXPfKVp`,
	"blue-2": `ELBsw9Ct6D`,
	"blue-3": `Bl8pp0ubDh`,
	"blue-4": `BRZBdVMQNk`,
	"blue-5": `S2NnYtDnYG`,
	"blue-6": `TTJNhy0xjN`,
	"yellow-1": `HR0cWlV0S9`,
	"yellow-2": `wWp63iVORv`,
	"yellow-3": `kkZ0kt7UUF`,
	"yellow-4": `HJQp43NO8X`,
	"yellow-5": `hNKOJBTicn`,
	"yellow-6": `C_e67KNyt7`,
	"purple-1": `meT418sFNa`,
	"purple-2": `Mp7HWaE5UK`,
	"purple-3": `FwNo4ADtBj`,
	"purple-4": `bKOE8PGdCM`,
	"purple-5": `iD2f5y_ZhX`,
	"purple-6": `AouyJPQADd`,
	"black-1": `l4KMbECR7F`,
	"black-2": `FjlugI7yTW`,
	"black-3": `XIGwTjPWdO`,
	"black-4": `hPgjmKNgFP`,
	"black-5": `kTFEczd9J_`,
	"black-6": `eUuady9LwQ`,
	"picker-theme": `sGR89rurjG`,
	"arrow-regular": `af_tyDscED`,
	"review-website__root": `pr_0pVY6tK`,
	"review-website__urls": `ni5KxILZnL`,
	"review-website__url": `jINu3fzujX`,
	"url-input__root": `rEsIQtgViw`,
	"url-input__bg": `C420CfwjvK`,
	"url-input__base": `BL9KcklRC5`,
	"url-input__base--isInvalid": `HXgNQ72ueQ`,
	"url-input__remove-icon": `cXrRBMIPQb`,
	"url-input__remove-icon--hide": `MLWLoRzsq7`,
	"urls__invalid": `IVyPx8GsGT`,
	"review-website__label": `tvaI80UHKc`,
	"review-website__controller": `tL_rN3xII_`,
	"controller-combine": `O8_pXzvisb`,
	"controller-combine__icon": `SWEQoXRoLU`,
	"controller-combine__label": `GgiACtnuWl`,
	"controller-typeOptions__label": `u73Eg3J835`,
	"controller-addUrl": `hqGKF8zbzt`,
	"controller-addUrl__label": `GpNJM0Rz0j`,
	"controller-typeOptions": `Ni_kJsGDen`,
	"controller-typeOptions__icon": `ziy4PS9FCb`
};
export default ___CSS_LOADER_EXPORT___;
